// services/abandonedCartService/events.ts - services/abandonedCartService.ts split (sub-module events)



/** Event name for abandoned cart save failures — komponen lain bisa listen */
export const ABANDONED_CART_ERROR_EVENT = 'abandoned-cart:error';
